import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
// eslint-disable-next-line import/order
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeofenceCondition, GeofenceType } from '../../models';
@Injectable({
  providedIn: 'root'
})
export class GeofenceService extends UzurvRestService {
  readonly resourceUrl = 'geofences/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * @permission geofence_management
   */
  listGeofenceConditions(): Observable<Array<GeofenceCondition>> {
    return this.get<Array<GeofenceCondition>>(`${this.resourceUrl}geofenceConditions/`, {
      pageNumber: 0,
      pageSize: 50
    }).pipe(map(response => Deserialize(response, GeofenceCondition)));
  }

  /**
   * @permission geofence_management
   */
  listGeofenceTypes(): Observable<Array<GeofenceType>> {
    return this.get<Array<GeofenceType>>(`${this.resourceUrl}geofenceTypes/`, {
      pageNumber: 0,
      pageSize: 50
    }).pipe(map(response => Deserialize(response, GeofenceType)));
  }
}
